export default "__VITE_ASSET__DcAXiZaT__"